import { render, staticRenderFns } from "./DTPHome.vue?vue&type=template&id=2d3f0d2b&"
import script from "./DTPHome.vue?vue&type=script&lang=js&"
export * from "./DTPHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports